import React from 'react';
import styled from 'styled-components';
import { Cell, HeaderCell, HeaderRow, Icon, Row, Table, TableBody, TableHead } from 'components';
import { theme, toRem } from 'design';
import { ITipCalculatorChangeLogEntry } from 'types';
import { buildChangeLogTableRows, IChangeLogTableRow, toTitleCase } from 'utils';

interface IChangeLogTableProps {
  changeLogEntries: ITipCalculatorChangeLogEntry[];
}

const TableWrapper = styled.section`
  width: 100%;
`;

const ItemSub = styled.span`
  font-weight: ${theme.font.weight.regular};
  color: ${theme.color.neutral[600]};
`;

const Details = styled.div`
  display: flex;

  svg {
    margin: 0 ${toRem(theme.space.xs)};
  }
`;

const ChangeLogTable: React.FC<IChangeLogTableProps> = ({ changeLogEntries }) => {
  const rows = buildChangeLogTableRows(changeLogEntries);

  const formatItem = ({ item: { name, segment, job, check } }: IChangeLogTableRow) => {
    if (!name) return segment || check;

    return (
      <>
        <span>{name}</span>
        {segment && <ItemSub>, {segment}</ItemSub>}
        {job && <ItemSub>, {toTitleCase(job)}</ItemSub>}
        {check && <ItemSub>, {check}</ItemSub>}
      </>
    );
  };

  const formatDetails = (entry: IChangeLogTableRow) => {
    if (!entry.details) return <Details>--</Details>;

    return (
      <Details>
        {entry.details.from} <Icon icon="ArrowRight" />
        {entry.details.to}
      </Details>
    );
  };

  return (
    <TableWrapper data-cy="table">
      <Table scrollable data-cy="change-log-table">
        <TableHead>
          <HeaderRow>
            <HeaderCell>Number</HeaderCell>
            <HeaderCell>Category</HeaderCell>
            <HeaderCell>Event</HeaderCell>
            <HeaderCell>Item</HeaderCell>
            <HeaderCell>Details</HeaderCell>
          </HeaderRow>
        </TableHead>
        <TableBody>
          {rows.map((entry: IChangeLogTableRow, idx: number) => (
            <Row key={`entry-${idx}`}>
              <Cell data-label="Number" fontSize="small">
                {entry.number}
              </Cell>
              <Cell data-label="Category" fontWeight="semiBold" fontSize="small">
                {entry.category}
              </Cell>
              <Cell data-label="Event" color={theme.color.neutral[600]} fontSize="small">
                {entry.event}
              </Cell>
              <Cell data-label="Item" fontWeight="semiBold" fontSize="small">
                {formatItem(entry)}
              </Cell>
              <Cell data-label="Details" color={theme.color.neutral[600]} fontSize="small">
                {formatDetails(entry)}
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};
export default ChangeLogTable;
